export default __webpack_public_path__ + "b87ec590a1ded5f9edff7d796255b027.svg";